import React, { Fragment } from "react"
import { getName, amb } from "../requests/utils"
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Container,
} from "reactstrap"

import { withRouter } from "react-router-dom"
class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = { dropOpen: false }
    this.toggle = this.toggle.bind(this)
    this.inicio = this.inicio.bind(this)
    this.muestraMenu = this.muestraMenu.bind(this)
    this.cierraSesion = this.cierraSesion.bind(this)
  }

  muestraMenu() {
    var d = document.getElementById("div_menu"),
      c = document.getElementById("dv_contenido"),
      m = document.getElementById("listaMenu")
    m.classList.remove("Hide_All")
    c.classList.add("mnu_obscurece")
    d.classList.add("dv_muestramenu")
  }

  toggle() {
    this.setState({ dropOpen: !this.state.dropOpen })
  }

  inicio() {
    //const { history } = this.props;
    //history.push("/user/");
    window.location = "/user"
  }

  cierraSesion() {
    localStorage.removeItem(`${amb}_login`)
    sessionStorage.removeItem(amb + "UD")
  }

  render() {
    return (
      <Fragment>
        <Container className="dv_header" fluid>
          <Row>
            <Col>
              <img
                src={require("../icons/iconmenu.png")}
                alt=""
                onClick={(e) => this.muestraMenu(e)}
              />
            </Col>
            <Col className="d-none d-sm-none d-md-block">
              <label>Reporteador Business Intelligence</label>
            </Col>
            <Col className="d-flex justify-content-end">
              <ButtonDropdown
                isOpen={this.state.dropOpen}
                toggle={(e) => this.toggle()}>
                <DropdownToggle caret className="btn_drpdwn">
                  {getName()}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem header>Opciones</DropdownItem>
                  <DropdownItem onClick={(e) => this.inicio(e)}>
                    Inicio
                  </DropdownItem>
                  <DropdownItem onClick={(e) => this.cierraSesion(e)}>
                    Cerrar sesión
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
            </Col>
            <Col
              sm="12"
              className="d-flex justify-content-center d-none d-block d-sm-block d-md-none">
              <label>Reporteador Business Intelligence</label>
            </Col>
          </Row>
        </Container>
      </Fragment>
    )
  }
}

export default withRouter(Header)
